module.exports = __webpack_public_path__ + "static/media/rchic_zong_hui_jin_se.77d61ebe.png";